import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { AppConfigService } from '../app-config.service.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  private uri = "";// `${environment.apiUrl}`;

  baseURI = '/Flexintegration/CallExtFlex'
  customerid = '';

  constructor(private http: HttpClient, private appConfigService: AppConfigService) {
    this.uri = this.appConfigService.apiBaseUrl;
    this.customerid = localStorage.getItem('customerid');
  }

  GetCustumerProject() {
    return this.http.post<any>(this.uri + '/Project/GetCustomerProjects',
      // { CustomerId: this.customerid })
      { CustomerId: 532 })
  }

  GetProjectBlogs(id) {
    return this.http.post<any>(this.uri + '/ProjectBlog', { id: id });
  }


  InsertUpdateProjectBlog(value) {
    return this.http.post<any>(this.uri + '/ProjectBlog/InsertUpdateProjectBlog', value);
  }

  Get_ProjectStatus(): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectStatus' });
  }

  GetProjectProgressByDateCE(date): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'GetProjectProgressByDateCE',
      tsdate: date
    });
  }

  Get_ProjectPhasesCE(): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration', { 
      method: 'Get_ProjectPhasesCE' 
    });
  }



  Get_InsertProjecttoWorkFlow(projectid): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration', { 
      // method: 'Get_ProjectPhasesCE' 
      method: 'Get_InsertProjecttoWorkFlow',
      projectid: projectid
    });
  }
  
  Get_ProjectByStatusandPhaseCE() {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_ProjectByStatusandPhaseCE'
      });
  }

  Get_ProjectByStatusandPhaseCEServiceContract() {
    return this.http.post<any>(this.uri + '/FlexIntegration',
      {
        method: 'Get_ServiceContractByStatusandPhaseCE'
      });
  }

  Update_ProjectPhasesCE(idproject, phaseids) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Update_ProjectPhasesCE',
      phaseid: phaseids,
      projectid: idproject,
    });
  }
  ProjectBillingStatusCE(idproject, statusid): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Update_ProjectCompletionStatusCE',
      projectid: idproject,
      completionstatusid: statusid

    });
  }

  InsertUpdateGridConfiguration(id, gridid, filterconfig, columnconfig, extraconfig?:any){
    let obj: any = {
      id: id,
      gridid: gridid,
      filterconfig: filterconfig,
      columnconfig: columnconfig,
      extraconfig:extraconfig,
      method: 'InsertUpdateGridConfiguration',
    }
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }

  InsertUpdateGridConfigurationVersion(id, gridid, filterconfig, columnconfig, versionconfig){
    let obj = {
      id: id,
      gridid: gridid,
      filterconfig: filterconfig,
      columnconfig: columnconfig,
      version: versionconfig,
      method: 'InsertUpdateGridConfiguration',
    }
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }

  InsertUpdateGridConfigurationVersionWithTitle(data){
    console.log(data)
    return this.http.post<any>(this.uri + '/FlexIntegration', data)
  }

  GetGridConfiguration(gridid){
    let obj = {
      gridid: gridid,
      method: 'GetGridConfiguration',
    }
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }

  GetGridMultipleConfigurations(gridid){
    let obj = {
      gridid: gridid,
      method: 'GetGridConfigurations',
    }
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }


  GetProjectByID(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectByID', projectid: id })
  }

  GetAllProjects(method) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: method });
  }
  
  Get_All_ProjectsPartsNyName(name){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_All_ProjectsPartsNyName', name: name});
  }

  Get_All_ServiceContractNyName(name){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_All_ServiceContractNyName', name: name});
  }

  Get_ServiceContractAllByame(name){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ServiceContractAllByame', projectname: name});
  }

  Get_All_ProjectsByName(name){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_All_ProjectsByName', name: name});
  }

  Get_All_SalesProjectsByName (nombre){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_All_SalesProjectsByName', name: nombre});
  }

  Get_ProjectsWithMatReq (nombre){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectsWithMatReq', name: nombre == null ? '' : nombre});
  }

  GetProjectsCategories(){
    return this.http.post<any>(this.uri + '/ProjectSalesCategory/', {});
  }

  InsertUpdateProjectAddress(obj) {
    // return this.http.post<any>(this.uri + '/Project/UpdateProjectAddress', obj);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  // Project Status

  InsertUpdateProjectStatus(id, status, startdate, duedate, compdate, warrantydate, warrantyid, percentcomp, projectname) {
    let obj = {
      id: id,
      projectid: id,
      statusid: status,
      // phaseid: phaseid,
      startdate: startdate,
      name: projectname,
      duedate: duedate,
      compdate: compdate,
      warrantydate: warrantydate,
      warrantyid: warrantyid,
      percentcomp: percentcomp,
      method: 'Update_ProjectChangeStatus'
    }
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetProjectStatus() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectStatus' });
  }

  Update_ProjectStatusDueDateCompletition(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', { 
      method: 'Update_ProjectStatusDueDateCompletition',
      projectid: obj.id,
      status: obj.status,
      duedate: obj.dudedate,
      completition: obj.percent   
    });
  }

  GetWarrantyTerms() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_WarrantyTerms' });
  }

  //Permits

  GetProjectPermits(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectPermits', projectid: id });
  }

  GetProjectPermitInspections(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectPermitInspection', projectid: id });
  }

  InsertUpdatePermits(form) {
    let obj = {
      id: form.id,
      projectid: form.projectid,
      projectpermitnumber: form.permitNumber,
      projectpermitnotes: form.permitNotes,
      datecreated: form.permitIssuedOn,
      lastmodified: form.permitExpiresOn,
      permitammount: form.permitAmount,
      method: 'InsertUpdate_EditPermits'
    }
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  InsertUpdateInspection(form) {
    let obj = {
      id: form.id,
      // projectid: form.projectid,
      permitid: form.permit,
      inspectiondate: form.inspectionDate,
      inspectiontype: form.inspectionType,
      inspectionresult: form.inspectionResult,
      inspectionassigntoid: form.assginedTo,
      inspectionneedbydate: '4/6/2021',
      inspectionnotes: form.notes,
      method: 'Insert_SaveUpdateProjectPermitInspection'
    }
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  //Contract Information
  GetPrevaillingWages() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_PrevailingWagesce' });
  }

  GetProjectTPostt(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_UpdateProjecTPosttoQB', projectid: id });
  }

  InsertUpdateProjectContractInfo(obj) {
    let method = { method: 'InsertUpdate_ProjectContractInfo' };
    Object.assign(obj, method)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  UpdateUnlockEstimate(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', {method: 'Update_ProjectChangeSoldStatus', projectid: id});
  }

  //Project Finanancial

  GetProjectFinnacialByProjectId(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Update_ProjectFinancialByProjectID', projectid: id });
  }

  GetProjectFinnacialByProjectId1(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Update_ProjectFinancialByProjectID-1', projectid: id });
  }

  GetSubcontractors(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectSubContractor_List', projectid: id });

  }
  GetEstimateVsActual(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectActualCostRevenueVsEstimateCostRevenue', projectid: id })
  }

  GetEstimateVsActualNew(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectActualCostRevenueVsEstimateCostRevenue', projectid: id })
  }

  GetLaborCost(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_LaborCostDetailByID', projectid: id })
  }

  GetMaterialCost(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_MaterialCostByID', projectid: id })
  }

  GetSubcontractorCost(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_SubcontractorCostDetailByID', projectid: id })
  }

  GetExpenseCost(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_ExpenseCostDetailByID', projectid: id })
  }

  GetMaterialRequest(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectMaterialRequestCE', projectid: id })
  }

  GetProjectFinancialDetailByCategory(id){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_FinancialDetailByCategory', projectid: id })
  }

  PostProjectToQB(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_UpdateProjecTPosttoQB', projectid: id })
  }

  Get_Method(obj){
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  //Customer Contact
  GetCustomerContactList(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectCustomerContact_List', projectid: id });
  }

  GetCustomerParticipantType() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectCustomerParticipantType' });
  }

  GetCustomerContactType() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectParticipantContactType' });
  }

  GetCustomerContactTypeAll(){
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_VerticalProjectParticipantContactTypeAll' });
  }

  InsertUpdateCustomer(form) {
    let obj = {
      method: 'Insert_SaveUpdateProjectCustomerContact',
    }
    Object.assign(obj, form);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetCustomers() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_CustomerCE' });
  }

  //Change Order
  GetChangeOrders(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_ChangeOrderCEByID', projectid: id })
  }

  GetDetailsChangeOrder(id) {
    let obj = { method: 'Get_Project_ChangeOrderDetailByID', changeid: id };
    return this.http.post<any>(this.uri + '/FlexIntegration', obj)
  }

  InsertUpdateChangeOrder(obj) {
    let method = { method: 'InsertUpdate_ProjectChangeOrder' };
    Object.assign(obj, method);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetProjectChangeOrderById(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_ChangeOrderHeaderCEByID', id: id })
  }

  InsertUpdateChangeOrderDetails(obj) {
    let method = { method: 'InsertUpdate_ProjectChangeOrderDetail'};
    Object.assign(obj, method);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  //Billing
  GetProjectRequisition(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectRequistionById', projectid: id })
  }

  GetRequisitionList(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectRequisitionListByProjectId', projectid: id })
  }

  GetCreditTerms() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_CustomerCreditTerms' })
  }

  GetBillingTax() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Taxs' })
  }

  GetBillingCategory() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_BillingCategory' })
  }

  Get_InserUpdateProjectPhasesCE(form) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_InserUpdateProjectPhasesCE',
      id: form.id,
      name: form.name,
      description: form.description,
      sort: form.sort,
      active: form.active
    });
  }
  Get_InserUpdateProjectStatusCE(form) {
    return this.http.post<any>(this.uri + '/FlexIntegration', {
      method: 'Get_InserUpdateProjectStatusCE',
      id: form.id,
      status: form.status,
      sort: form.sort,
      active: form.active
    });
  }

  //Project WorkFlow
  GetWorkflowList(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_WorkflowByID', projectid: id });
  }

  GetWorkflowListPhase(id,phaseid) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_WorkflowByID', projectid: id, phaseid:phaseid});
  }

  GetStatusList() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Project_WorkflowStatus' });
  }

  UpdateProjectWorkFlow(form) {
    let obj = { method: 'Get_UpdateProjectWorkFlow' }
    Object.assign(obj, form)
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  //Schedule of Values
  // GetBillingSchedule(id) {
  //   return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectsovById', projectid: id });
  // }
  GetBillingSchedule(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectSOVById_v2', projectid: id });
  }

  Get_ProjectSOVById_v2(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectSOVById_v2', projectid: id });
  }

  GetBillingCategorys() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_BillingCategory ' });
  }

  GetTaxes() {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_Taxs' });
  }

  UpdateProjectTax(projectid, salestaxid) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Update_ProjectTax ', projectid: projectid, salestaxid: salestaxid });
  }

  DelteBillingSchedule(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Delete_BillingSchedule', projectpartestdetailid: id });
  }

  DuplicateBillingSchedule(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Duplicate_BillingSchedule', projectpartdetailid: id });
  }

  InsertUpdateSchedule(obj) {
    let method = { method: 'InsertUpdate_ProjectPartDetail' }
    Object.assign(obj, method);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  GetOndemandwater(method, name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: method, partnamefilter: name, only_pwfms:1 });
  }

  GetOndemandAir(method, name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: method, partnamefilter: name, only_pafms:1 });
  }

  GetAllParts(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_AccParts', partnamefilter: name });
  }

  GetAllMR(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_MaterialRequestAllPagedCE', materialrequest: name });
  }

  GetAllPartsNew(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_AccPartsNumswithManufacturer', partnamefilter: name });
  }

  Get_LaborParts(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_LaborParts', partnamefilter: name });
  }

  GetAllPartsMaster(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_AccPartsMaster', partnamefilter: name });
  }

  GetAllParts2(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_EstimatePartsValves', partnamefilter: name });
  }

  GetPartsValve(name, valveConfigurationSelected?:any, valveTypeSelected?:any, valveSystemTypeSelected?:any, signalSelected?:any, valveLineSelected?:any, valveSizeSelected?:any) {
    
    if (valveConfigurationSelected == undefined && valveTypeSelected == undefined && valveSystemTypeSelected == undefined && 
      signalSelected == undefined && valveSizeSelected == undefined){
        
        return this.http.post<any>(this.uri + '/FlexIntegration', { 
          method: 'Get_EstimatePartsValves', 
          // partnamefilter: name,
          partnamefilter: name == " " ? -1 : name,
          valvepipecongid: valveConfigurationSelected == undefined ? -2 : valveConfigurationSelected,
          valvetypeid: valveTypeSelected == undefined ? -2 : valveTypeSelected,
          valvesystemid: valveSystemTypeSelected == undefined ? -2 : valveSystemTypeSelected,
          valveacttypeid: signalSelected == undefined ? -2 : signalSelected,
          // valvegpm: valveLineSelected == undefined ? -2 : valveLineSelected,
          valvegpm: -2,
          valvesizeid: valveSizeSelected == undefined ? -2 : valveSizeSelected,
        });

      } else {

        return this.http.post<any>(this.uri + '/FlexIntegration', { 
          method: 'Get_EstimatePartsValves', 
          partnamefilter: name,
          // partnamefilter: name == " " ? -2 : name,
          valvepipecongid: valveConfigurationSelected == undefined ? -1 : valveConfigurationSelected,
          valvetypeid: valveTypeSelected == undefined ? -1 : valveTypeSelected,
          valvesystemid: valveSystemTypeSelected == undefined ? -1 : valveSystemTypeSelected,
          valveacttypeid: signalSelected == undefined ? -1 : signalSelected,
          // valvegpm: valveLineSelected == undefined ? -1 : valveLineSelected,
          valvegpm: -1,
          valvesizeid: valveSizeSelected == undefined ? -1 : valveSizeSelected,
        });
      }
    
  }


  GetPartsValvenew(name, valveConfigurationSelected?:any, valveTypeSelected?:any, valveSystemTypeSelected?:any, signalSelected?:any, valveLineSelected?:any, valveSizeSelected?:any, designcv?:any) {
    
    if (valveConfigurationSelected == undefined && valveTypeSelected == undefined && valveSystemTypeSelected == undefined && 
      signalSelected == undefined && valveSizeSelected == undefined){
        
        return this.http.post<any>(this.uri + '/FlexIntegration', { 
          method: 'Get_EstimatePartsValves', 
          // partnamefilter: name,
          partnamefilter: name == " " ? -1 : name,
          valvepipecongid: valveConfigurationSelected == undefined ? -2 : valveConfigurationSelected,
          valvetypeid: valveTypeSelected == undefined ? -2 : valveTypeSelected,
          valvesystemid: valveSystemTypeSelected == undefined ? -2 : valveSystemTypeSelected,
          valveacttypeid: signalSelected == undefined ? -2 : signalSelected,
          // valvegpm: valveLineSelected == undefined ? -2 : valveLineSelected,
          valvegpm: -2,
          valvesizeid: valveSizeSelected == undefined ? -2 : valveSizeSelected,
          designcv:designcv == undefined ? -2 : designcv,
        });

      } else {

        return this.http.post<any>(this.uri + '/FlexIntegration', { 
          method: 'Get_EstimatePartsValves', 
          partnamefilter: name,
          // partnamefilter: name == " " ? -2 : name,
          valvepipecongid: valveConfigurationSelected == undefined ? -1 : valveConfigurationSelected,
          valvetypeid: valveTypeSelected == undefined ? -1 : valveTypeSelected,
          valvesystemid: valveSystemTypeSelected == undefined ? -1 : valveSystemTypeSelected,
          valveacttypeid: signalSelected == undefined ? -1 : signalSelected,
          // valvegpm: valveLineSelected == undefined ? -1 : valveLineSelected,
          valvegpm: -1,
          valvesizeid: valveSizeSelected == undefined ? -1 : valveSizeSelected,
          designcv:designcv == undefined ? -2 : designcv,
        });
      }
    
  }


  GetPartsDampernew(datos) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { 
      method: 'Get_EstimatePartsDamperActuator', 
      parttorque:datos.parttorque,
      valveacttypeid:datos.valveacttypeid,
      valvepwr:datos.valvepwr,
      partnamefilter: datos.partnamefilter
    });
    
  }

  GetPartsWithInventory(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_AccPartsTypeInventory', partnamefilter: name });
  }

  GetAllPartsDetail(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_AccPartsServiceDetailWithFilter', partnamefilter: name });
  }

  GetAllPartsDetailCubeBox(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_AccPartsServiceDetailWithFilterMaterial', partnamefilter: name });
  }

  GetAllLaborDetailCubeBox(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_AccPartsServiceDetailWithFilterLabor', partnamefilter: name });
  }

  GetAllProblem(name) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'GetServiceHistoryProblem', problemtext: name, systemid:null });
  }

  GetProjectPartDetail(number) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectPartDetailSugestedValues', partnumber: number, });
  }

  GetProjectPartDetail2(number, projectid) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectPartDetailSugestedValues', partnumber: number, projectid: projectid });
  }

  SaveEditMultiple(obj) {
    let method = { method: 'EditMultiple_BillingSchedule ' }
    Object.assign(obj, method);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  SaveRequest(obj) {
    let method = { method: 'Save_ProjectMaterialRequestCE ' }
    Object.assign(obj, method);
    return this.http.post<any>(this.uri + '/FlexIntegration', obj);
  }

  //Progress Report
  InsertProgressReport(form) {
    let method = { method: 'InsertProjectProgressCE' };
    Object.assign(form, method);
    return this.http.post<any>(this.uri + '/FlexIntegration', form);
  }

  GetProgressReport(id) {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'GetProjectProgressCE', projectid: id });
  }
  Get_ProjectsAnalysisProfit(): Observable<any> {
    return this.http.post<any>(this.uri + '/FlexIntegration', { method: 'Get_ProjectsAnalysisProfit' })
  }
  Get_OpenPunchListItemAll(): Observable<any> {
    return this.http.post<any>(this.uri + "/Flexintegration", {
      method: 'Get_OpenPunchListItemAll'
    })
  }
  Get_ProjectsLaborProjection(date): Observable<any> {
    return this.http.post<any>(this.uri + "/Flexintegration", {
      method: 'Get_ProjectsLaborProjection',
      tsdate: date
    })
  }

  Get_ProjectsRevenueProjection(date): Observable<any> {
    return this.http.post<any>(this.uri + "/Flexintegration", {
      method: 'RevenueProjection',
      tsdate: date
    })
  }
  Get_Project_WorkflowListCE(): Observable<any> {
    return this.http.post<any>(this.uri + "/Flexintegration", {
      method: 'Get_Project_WorkflowListCE'
    })
  }
  Get_Project_WorkflowListCEByPhaseID(id): Observable<any> {
    return this.http.post<any>(this.uri + "/Flexintegration", {
      method: 'Get_Project_WorkflowListCEByPhaseID',
      phaseid:id
    })
  }
  Get_Dashboard_PROJECT_STATUS_DASHBOARD(): Observable<any> {
    return this.http.post<any>(this.uri + "/Flexintegration", {
      method: 'DashboardComponents_Get_Dashboard_PROJECT_STATUS_DASHBOARD'
    })
  }

  NotificationsProgressReport(obj){
    return this.http.post(this.uri + '/Notifications/NotificationProgress', obj )
  }


  Get_ProjectsCustomData(val = null) {
    let model = {
      method: "Get_All_SalesProjectsByNameCubeShop",
      name: val
    };
    return this.http.post<any>(this.uri + this.baseURI , model);
  }

}
